// Shared by the weekly and monthly roster.
export const PAID_LEAVE = ["Annual leave", "Sick"];
// Two shifts for the same person on the same day that can't both be worked: overlapping times, or the
// same shift type when either has no times.
export const clashes = (a, b) => {
  if (a.staffId !== b.staffId || a.day !== b.day) return false;
  if (a.start && a.end && b.start && b.end) return a.start < b.end && b.start < a.end;
  return a.programme === b.programme;
};
export const FALLBACK_SPAN = { "Before School": ["07:00", "08:30"], "After School": ["15:00", "18:00"], "Holiday Programme": ["07:00", "18:00"], "Special days": ["08:30", "15:30"], "Admin": ["09:00", "15:00"] };

export const toH = ([, h, mm, ap]) => { let hh = parseInt(h, 10) + (parseInt(mm || "0", 10) / 60); const a = (ap || "").toLowerCase(); if (a === "pm" && hh < 12) hh += 12; if (a === "noon") hh = 12; return hh; };
export const hhmm = (h) => `${String(Math.floor(h)).padStart(2, "0")}:${String(Math.round((h % 1) * 60)).padStart(2, "0")}`;
export const programmeSpan = (p, sessions) => {
  const times = [];
  (sessions || []).forEach((s) => {
    const m = [...(s.name || "").matchAll(/(\d{1,2})(?::(\d{2}))?\s*(am|pm|noon)/gi)];
    m.forEach((x) => times.push(toH(x)));
  });
  if (times.length < 2) return FALLBACK_SPAN[p] || ["09:00", "15:00"];
  return [hhmm(Math.min(...times)), hhmm(Math.max(...times))];
};
export const hoursFromTimes = (a, b) => { if (!a || !b) return null; const [h1, m1] = a.split(":").map(Number), [h2, m2] = b.split(":").map(Number); const d = (h2 + m2 / 60) - (h1 + m1 / 60); return d > 0 ? Math.round(d * 4) / 4 : null; };

export const assignSlots = (list) => {
  const used = {};
  return list.map((e) => {
    const key = `${e.programme}|${e.day}`;
    const taken = used[key] || (used[key] = new Set());
    let slot = Number.isInteger(e.slot) ? e.slot : 0;
    while (taken.has(slot)) slot += 1;
    taken.add(slot);
    return { ...e, slot, hours: String(e.hours) };
  });
};

